angular.module('ui.order.orderItemCard.orderItemFiles', [
    'ui.order.orderItemCard.orderItemFiles.fileUpload',
    'ui.order.orderItemCard.orderItemFiles.dataSizeFilter',
    'ui.order.orderItemCard.orderItemFiles.checkDuplicatesService'
])

    .directive('orderItemFiles', function () {
        return {
            restrict: 'E',
            scope: {},
            templateUrl: 'app/ui/order/orderItemCard/orderItemFiles/orderItemFiles.html',
            controller: 'OrderItemFilesController'
        };
    })

    .controller('OrderItemFilesController', function ($scope, toastr, $document,
                                                      orderItemsRepository, authService,
                                                      checkDuplicatesService, filesControllerUpdatesService,
                                                      orderItemCardDataProvider, $http, $log) {
        $scope.baseUrl = om.config.build.baseUrl;

        $scope.currentPage = 0;
        $scope.pageSize = 15;

        $scope.loadingDocuments = false;
        $scope.validate = validate;
        $scope.getDocument = getDocument;
        $scope.numberOfPages = numberOfPages;
        $scope.someFileUploaded = someFileUploaded;
        $scope.documentsCount = 3; //Just for default 'loading templates' view

        $scope.nextPage = function () { $scope.currentPage++; }
        $scope.prevPage = function () { $scope.currentPage--; }

        checkDuplicatesService.getAlreadyUploadedFiles = function () {
            return $scope.documents;
        };

        filesControllerUpdatesService.onNewDocument(function () {
            $scope.$applyAsync(function () {
                refreshDocList();
            });
        });

        orderItemCardDataProvider.onDataChange('OrderItemFilesController', function () {
            if ($scope.orderItemId === orderItemCardDataProvider.getOrderItemId()) {
                return;
            }
            $scope.$applyAsync(function () {
                $scope.orderItemId = orderItemCardDataProvider.getOrderItemId();

                refreshDocList();
            });
        });

        $scope.$on("$destroy", function () {
            filesControllerUpdatesService.onNewDocument(void 0);
            orderItemCardDataProvider.onDataChange('OrderItemFilesController', void 0);
        });

        initController();

        function initController() {
            refreshDocList();
        }

        function numberOfPages() {
            var length = $scope.documents ? $scope.documents.length : 0;
            return Math.ceil(length / $scope.pageSize);
        }

        function getDocument(documentId) {

            var form = document.createElement("form");
            form.method = "POST";
            form.action = om.config.build.baseUrl + "/documents/" + documentId + "/download";
            form.setAttribute("style", "display:none");

            var input = document.createElement("input");
            input.setAttribute("name", "Authorization");
            input.setAttribute("value", authService.getToken());
            form.appendChild(input);
            form.submit();
        }

        function someFileUploaded() {
            refreshDocList();
        }

        function validate() {
            return true;
        }

        function refreshDocList() {
            $scope.currentPage = 0;
            var orderItem = orderItemCardDataProvider.getOrderItem();

            if (!orderItem) {
                $scope.documents = null;
                return $scope.documents;
            }

            $scope.loadingDocuments = true;

            if (orderItem.$model.documents) {
                //init the count for 'loading templates' right away while we updating documents info by loading from server
                $scope.documentsCount = orderItem.$model.documents.length;

                //Looks like we are safe to show documents that we have and then just explicitly update them just in case
                //But we should be ok in most cases to show them rightaway as we have them loaded on the models as sub resources already
                $scope.documents = orderItem.$model.documents;
            }

            //Explicitly refresh documents from server here (makes it fail proof if somebody made documents custom fields to be lazy loaded)
            return orderItemsRepository.getDocuments(orderItem)
                .then(
                    function (documents) {
                        $scope.currentPage = 0;
                        $scope.loadingDocuments = false;
                        $scope.documents = documents;
                        $scope.documentsCount = documents.length;
                        return documents;
                    },
                    function (error) {
                        $scope.currentPage = 0;
                        $scope.loadingDocuments = false;
                        toastr.error(error.message, "Can't load documents");
                        $log.error("Can't load documents of orderItem `%s`. Cause: %s", $scope.orderItemId, error.message);
                    });
        }
    })

    // Separate service for update events (to prevent multiple event subscription)
    .service('filesControllerUpdatesService', function (rest) {
        var _this = this;
        var callback;

        rest.events.on("modelCreatedOnServer", function (modelInfo) {
            if (!callback) {
                return;
            }
            if (modelInfo && modelInfo.modelType == "DocumentModel") {
                callback(modelInfo);
            }
        });

        _this.onNewDocument = function (cb) {
            callback = cb;
        };

        return _this;
    })

    .filter('startFrom', function () {
        return function (input, start) {
            if (!input || !input.length) {
                return;
            }
            start = +start; //parse to int
            return input.slice(start);
        }
    })

;
